import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { Settings as SettingsIcon } from 'lucide-react';
const Settings = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-4056">
      <div className="w-20 flex-shrink-0" data-id="element-4057">
        <Sidebar data-id="element-4058" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4059">
        <Topbar data-id="element-4060" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-4061">
          <PageHeader title="Impostazioni" subtitle="Configura le impostazioni della piattaforma" data-id="element-4062" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-4063">
            <div className="text-center" data-id="element-4064">
              <SettingsIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-4065" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-4066">
                Impostazioni
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-4067">
                Questa pagina conterrà le impostazioni della piattaforma. Coming
                soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Settings;